import Vue from 'vue';
import VueRouter from 'vue-router';

const LoginComponent = () => import('../components/Login.vue');
const InstancesComponent = () => import('../components/Instances/Instances.vue');
const UsersComponent = () => import('../components/Users/Users.vue');
const SalesComponent = () => import('../components/Sales/Sales.vue');
const PlansComponent = () => import('../components/Plans/Plans.vue');
const AddonsComponent = () => import('../components/Addons/Addons.vue');
const ChannelsComponent = () => import('../components/Channels/Channels.vue');
const InstanceManagerComponent = () => import('../components/InstanceManagers/InstanceManagers.vue');
const SignupComponent = () => import('../components/Share/InstanceSignup/Signup.vue');
const InstanceAppSettingComponent = () => import('../components/InstanceAppSettings/InstanceAppSettings.vue');
const AccountHandlersComponent = () => import('../components/AccountHandlers/AccountHandlers.vue');

Vue.use(VueRouter);

export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/Login',
      name: 'login',
      component: LoginComponent
    },
    {
      path: '/Sales',
      name: 'sales',
      component: SalesComponent
    },
    {
      path: '/instances',
      name: 'instances',
      component: InstancesComponent
    },
    {
      path: '/users',
      name: 'users',
      component: UsersComponent
    },
    {
      path: '/plans',
      name: 'plans',
      component: PlansComponent
    },
    {
			path: '/addons',
			name: 'addons',
			component: AddonsComponent
		},
    {
      path: '/channels',
      name: 'channels',
      component: ChannelsComponent
    },
    {
      path: '/accountHandler',
      name: 'accountHandler',
      component: AccountHandlersComponent
    },
    {
      path: '/',
      name: 'default',
      component: InstancesComponent
    },
    {
      path: '/instanceManager',
      name: 'instanceManager',
      component: InstanceManagerComponent
    },
    {
      path: '/signup',
      name: 'signUp',
      component: SignupComponent
    },
    {
      path: '/instanceAppSetting',
      name: 'instanceAppSetting',
      component: InstanceAppSettingComponent
    },
    { path: '*', redirect: '/' }
  ],
});
